import Network from './network';

export default {
  create(watercoolerId, params, callbacks) {
    Network.post(
      `/watercooler/${watercoolerId}/watercooler_packs_watercoolers/create_as_json`,
      { watercooler_packs_watercooler: params },
      callbacks,
    );
  },

  destroy(watercoolerId, params, callbacks) {
    Network.delete(
      `/watercooler/${watercoolerId}/watercooler_packs_watercoolers/destroy_as_json`,
      { watercooler_packs_watercooler: params },
      callbacks,
    );
  },
};
